import React from "react";

import StatusScreen, { Loading } from "components/StatusScreen";
import PlayerOutline from "features/player/PlayerOutline";
import PlayerStage from "features/player/PlayerStage";
import PlayerTopBar from "features/player/PlayerTopBar";
import usePlayer from "features/player/usePlayer";

// Lesson player in univ.mekari.com's layout: top bar, outline left, lesson right.
export default function Player({ match, history, location }) {
  const player = usePlayer(match.params, history, location.search);

  if (player.status === "error") return <StatusScreen>{player.message ?? "Something went wrong"}</StatusScreen>;
  if (player.status === "loading" || !player.current) return <Loading />;

  return (
    <div className="yc-player">
      <PlayerTopBar />
      <div className="yc-player-body">
        <PlayerOutline {...player} />
        <PlayerStage {...player} />
      </div>
    </div>
  );
}
